import { actionCreator } from 'utils';
import {
    LOAD_USERS,
    LOAD_USERS_GROUPS,
    LOAD_USERS_GROUPS_FOR_USERS,
    LOAD_RESELLERS,
    LOAD_PERMISSION_GROUP,
    SET_USER_PAGINATION,
    SET_USER_SORT,
    SET_DISABLE_USER,
    SET_RESELLER_FILTER,
    SET_USER_NAME_FILTER,
    SET_PERMISSION_NAME_FILTER,
    SET_USER_STATUS_FILTER,
    SET_USER_GROUPE_FILTER,
    SET_PERMISSION_GROUP_FILTER,
    SET_EMPTY_EDITABLE_USER,
    RESET_FILTER_USERS,
    RESET_FILTER_USERS_GROUPS,
    ADD_NEW_USER,
    LOAD_EDITTABLE_USER,
    SET_EMPTY_EDITTABLE_USER,
    EDIT_USER,
    ADD_NEW_USER_GROUP,
    LOAD_EDITTABLE_USER_GROUP,
    SET_EMPTY_EDITTABLE_USER_GROUP,
    SELECT_PERMISSIONS_GROUPS,
    EDIT_USER_GROUP,
} from '../types/userTypes';

const initState = {
    loading: false,
    error: false,
    success: false,
    offset: 0,
    limit: 10,
    sort: null,
    disable: false,
    permissionGroupId: '',
    listingUser: {},
    listingUserGroupe: {},
    listingUserGroupeForUsers: {},
    listingResseler: {},
    listingPermissionGroup: {},
    filters: {
        name: '',
        email: '',
        reseller: [],
        userGroupe: [],
        status: undefined,
        permissionGroup: [],
        permissionName: '',
    },
    addUser: {
        loading: false,
        error: false,
        success: false,
        current: 0,
    },
    editUser: {
        loading: false,
        data: null,
        error: false,
        success: false,
    },
    addUserGroup: {
        loading: false,
        error: false,
        success: false,
        current: 0,
    },
    editUserGroup: {
        loading: false,
        data: null,
        error: false,
        success: false,
    },
};


export default function (state = initState, action) {
    switch (action.type) {
    // L O A D    U S E R S
    case LOAD_USERS:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(LOAD_USERS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listingUser: action.data,
        });

    case actionCreator(LOAD_USERS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case SET_USER_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case SET_USER_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case SET_DISABLE_USER:
        return Object.assign({}, state, {
            disable: action.value,
        });

        // LOAD_RESELLERS
    case LOAD_RESELLERS:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(LOAD_RESELLERS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listingResseler: action.data,
        });

    case actionCreator(LOAD_RESELLERS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case SET_RESELLER_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                reseller: action.key,
            },
        });

    case actionCreator(SET_RESELLER_FILTER, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listingUser: action.data,
        });

    case SET_USER_NAME_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(SET_USER_NAME_FILTER, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listingUser: action.data,
        });

    case SET_USER_STATUS_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(SET_USER_STATUS_FILTER, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listingUser: action.data,
        });

        // L O A D   U S E R S   G R O U P S
    case LOAD_USERS_GROUPS:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(LOAD_USERS_GROUPS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listingUserGroupe: action.data,
        });

    case actionCreator(LOAD_USERS_GROUPS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case LOAD_USERS_GROUPS_FOR_USERS:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(LOAD_USERS_GROUPS_FOR_USERS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listingUserGroupeForUsers: action.data,
        });

    case actionCreator(LOAD_USERS_GROUPS_FOR_USERS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case SET_USER_GROUPE_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                userGroupe: action.key,
            },
        });

    case actionCreator(SET_USER_GROUPE_FILTER, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listingUser: action.data,
        });

    case LOAD_PERMISSION_GROUP:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(LOAD_PERMISSION_GROUP, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listingPermissionGroup: action.data,
        });

    case actionCreator(LOAD_PERMISSION_GROUP, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case SET_PERMISSION_NAME_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(SET_PERMISSION_NAME_FILTER, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listingUserGroupe: action.data,
        });

    case SET_PERMISSION_GROUP_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                permissionGroup: action.key,
            },
        });

    case actionCreator(SET_PERMISSION_GROUP_FILTER, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listingUserGroupe: action.data,
        });

    case SET_EMPTY_EDITABLE_USER:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: null,
                error: false,
            }),
        });

    case RESET_FILTER_USERS:
        return Object.assign({}, state, {
            ...state,
            loading: true,
            filters: {
                ...state.filters,
                name: '',
                email: '',
                reseller: [],
                userGroupe: [],
                status: undefined,
            },
        });

    case actionCreator(RESET_FILTER_USERS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listingUser: action.data,
        });

    case RESET_FILTER_USERS_GROUPS:
        return Object.assign({}, state, {
            ...state,
            loading: true,
            filters: {
                ...state.filters,
                permissionName: '',
                permissionGroup: [],
            },
        });

    case actionCreator(RESET_FILTER_USERS_GROUPS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listingUserGroupe: action.data,
        });

    // / ///  F O R M   U S E R S  /// ///
    case ADD_NEW_USER:
        return Object.assign({}, state, {
            addUser: Object.assign({}, state.addUser, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(ADD_NEW_USER, 'res'):
        return Object.assign({}, state, {
            addUser: Object.assign({}, state.addUser, {
                loading: action.loading,
                error: false,
                success: action.success,
            }),
        });

    case actionCreator(ADD_NEW_USER, 'err'):
        return Object.assign({}, state, {
            addUser: Object.assign({}, state.addUser, {
                loading: false,
                error: action.error,
            }),
        });

    case LOAD_EDITTABLE_USER:
        return Object.assign({}, state, {
            editUser: Object.assign({}, state.editUser, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(LOAD_EDITTABLE_USER, 'res'):
        return Object.assign({}, state, {
            editUser: Object.assign({}, state.editUser, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(LOAD_EDITTABLE_USER, 'err'):
        return Object.assign({}, state, {
            editUser: Object.assign({}, state.editUser, {
                loading: false,
                error: true,
            }),
        });

    case SET_EMPTY_EDITTABLE_USER:
        return Object.assign({}, state, {
            editUser: Object.assign({}, state.editUser, {
                loading: false,
                data: null,
                error: false,
            }),
        });

    case EDIT_USER:
        return Object.assign({}, state, {
            editUser: Object.assign({}, state.editUser, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(EDIT_USER, 'res'):
        return Object.assign({}, state, {
            editUser: Object.assign({}, state.editUser, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(EDIT_USER, 'err'):
        return Object.assign({}, state, {
            editUser: Object.assign({}, state.editUser, {
                loading: false,
                error: true,
            }),
        });

    // / ///  F O R M   U S E R S   G R O U P S  /// ///
    case ADD_NEW_USER_GROUP:
        return Object.assign({}, state, {
            addUserGroup: Object.assign({}, state.addUserGroup, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(ADD_NEW_USER_GROUP, 'res'):
        return Object.assign({}, state, {
            addUserGroup: Object.assign({}, state.addUserGroup, {
                loading: action.loading,
                error: false,
                // success: action.success,
            }),
        });

    case actionCreator(ADD_NEW_USER_GROUP, 'err'):
        return Object.assign({}, state, {
            addUserGroup: Object.assign({}, state.addUserGroup, {
                loading: false,
                error: action.error,
            }),
        });

    case LOAD_EDITTABLE_USER_GROUP:
        return Object.assign({}, state, {
            editUserGroup: Object.assign({}, state.editUserGroup, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(LOAD_EDITTABLE_USER_GROUP, 'res'):
        return Object.assign({}, state, {
            editUserGroup: Object.assign({}, state.editUserGroup, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(LOAD_EDITTABLE_USER_GROUP, 'err'):
        return Object.assign({}, state, {
            editUserGroup: Object.assign({}, state.editUserGroup, {
                loading: false,
                error: true,
            }),
        });

    case SET_EMPTY_EDITTABLE_USER_GROUP:
        return Object.assign({}, state, {
            editUserGroup: Object.assign({}, state.editUserGroup, {
                loading: false,
                data: null,
                error: false,
            }),
        });

    case SELECT_PERMISSIONS_GROUPS:
        return Object.assign({}, state, {
            permissionGroupId: Object.assign({}, state.permissionGroupId, {
                data: action.data,
            }),
        });

    case EDIT_USER_GROUP:
        return Object.assign({}, state, {
            editUserGroup: Object.assign({}, state.editUserGroup, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(EDIT_USER_GROUP, 'res'):
        return Object.assign({}, state, {
            editUserGroup: Object.assign({}, state.editUserGroup, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(EDIT_USER_GROUP, 'err'):
        return Object.assign({}, state, {
            editUserGroup: Object.assign({}, state.editUserGroup, {
                loading: false,
                error: true,
            }),
        });


    default:
        return state;
    }
}
